export enum EPaymentMethod {
    card = 'card',
    button = 'button',
}
